import { render, staticRenderFns } from "./add.vue?vue&type=template&id=07d56ff5&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=07d56ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d56ff5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d56ff5')) {
      api.createRecord('07d56ff5', component.options)
    } else {
      api.reload('07d56ff5', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=07d56ff5&scoped=true&", function () {
      api.rerender('07d56ff5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/chatAbnormalUser/components/add.vue"
export default component.exports